import React from 'react';
import {ISvgIconProps} from '../../basic-ui-components/icon/svg-icon/svg.icon';
import {IThemeIcons} from './sections/theme-icons.interface';
import {ThemeDefaultIcons} from '../defaults/icons-registry';
import { ITwoCharsIconProps } from '../defaults/icons/two-chars.icon';

export class ThemeIconsFactory implements IThemeIcons {
    constructor(private readonly _specificThemeIcons: Partial<IThemeIcons> | null) {
        this._specificThemeIcons = this._specificThemeIcons || {};
    }

    private _getIcon(key: keyof IThemeIcons): React.ComponentType<ISvgIconProps> {
        if(this._specificThemeIcons[key]) {
            return this._specificThemeIcons[key];
        } else {
            return ThemeDefaultIcons[key];
        }
    }

    get addIcon() {
        return this._getIcon("addIcon");
    }

    get infoIcon() {
        return this._getIcon("infoIcon");
    }

    get backIcon() {
        return this._getIcon("backIcon");
    }

    get forwardIcon() {
        return this._getIcon("forwardIcon");
    }

    get closeIcon() {
        return this._getIcon("closeIcon");
    }

    get helpIcon() {
        return this._getIcon("helpIcon");
    }

    get safeZoneIcon() {
        return this._getIcon("safeZoneIcon");
    }

    get twoCharsIcon() {
        return this._getIcon("twoCharsIcon") as React.ComponentType<ITwoCharsIconProps>;
    }

    get earthGlobeIcon() {
        return this._getIcon("earthGlobeIcon");
    }

    get topGamesIcon() {
        return this._getIcon("topGamesIcon");
    }
    get rouletteIcon() {
        return this._getIcon("rouletteIcon");
    }
    get blackjackIcon() {
        return this._getIcon("blackjackIcon");
    }
    get eliteLoungeIcon() {
        return this._getIcon("eliteLoungeIcon");
    }
    get pokerIcon() {
        return this._getIcon("pokerIcon");
    }
    get baccaratIcon() {
        return this._getIcon("baccaratIcon");
    }
    get gameShowsIcon() {
        return this._getIcon("gameShowsIcon");
    }
    get newGamesIcon() {
        return this._getIcon("newGamesIcon");
    }
    get linkToOfferIcon() {
        return this._getIcon("linkToOfferIcon");
    }

    get linkToOfferCloseIcon() {
        return this._getIcon("linkToOfferCloseIcon");
    }
    get sourceOfFundsIcon(){
        return this._getIcon('sourceOfFundsIcon');
    }

    get arrowsUpDownIcon() {
        return this._getIcon('arrowsUpDownIcon');
    }
    get megaphoneIcon() {
        return this._getIcon('megaphoneIcon');
    }
    get chipIcon() {
        return this._getIcon('chipIcon');
    }
    get settingsIcon() {
        return this._getIcon('settingsIcon');
    }

    get viewersIcon() {
        return this._getIcon('viewersIcon');
    }

    get muteIcon() {
        return this._getIcon('muteIcon');
    }

    get unmuteIcon() {
        return this._getIcon('unmuteIcon');
    }

    get brokenLinkIcon() {
        return this._getIcon('brokenLinkIcon');
    }

    get timeSpentReminderClockIcon() {
        return this._getIcon('timeSpentReminderClockIcon');
    }
}